<template>
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="8" :sm="24">
            <a-form-item label="车号/企业/人员">
              <a-input v-model.trim="queryParam.name" placeholder="请输入" />
            </a-form-item>
          </a-col>
          <a-col :md="8" :sm="24">
            <a-form-item label="类型">
              <a-select v-model="queryParam.type" placeholder="请选择">
                <a-select-option value>全选</a-select-option>
                <a-select-option
                  v-for="(item, index) in typeSelect"
                  :key="index"
                  :value="item.value"
                >{{ item.name }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>

          <a-col :md="8" :sm="24">
            <a-form-item label="还原类型">
              <a-select v-model="queryParam.status" placeholder="请选择">
                <a-select-option value>全选</a-select-option>
                <a-select-option value="00">可初步还原</a-select-option>
                <a-select-option value="3">可确认还原</a-select-option>

              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="8" :sm="24">
            <span class="table-page-search-submitButtons">
              <a-button type="primary" @click="$refs.table.refresh(true)">查询</a-button>
              <a-button style="margin-left: 8px" @click="() => queryParam = {}">重置</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <s-table
      ref="table"
      size="default"
      :bordered="config.globlaBordered"
      :rowKey="(record) => record.id"
      :columns="columns"
      :data="loadData"
      :scroll="{ x:1200 }"
      :alert="options.alert"
      :rowSelection="options.rowSelection"
      :pagination="{pageSizeOptions:pageSizeOptionsList,showTotal:total => `共${total}条`}"
    >
      <span slot="serial" slot-scope="text, record, index">{{ index + 1 }}</span>

      <span slot="action" slot-scope="text, record">
       <!-- <a @click="handleDel(record)">还原</a>
         <a-divider  type="vertical" />-->
         <a v-if="record.status !='3'" @click="handleRecover(record,'')">还原</a>
         <a-divider  type="vertical" />
         <a v-if="(record.status=='3') && (roleId === config.RoleType.DISPATCH_SUP || roleId === config.RoleType.ADMIN)" @click="handleRecover(record,'1')">还原确认</a>
      </span>
    </s-table>

    <a-modal title="拉黑恢复" :width="640" v-model="recoverModel" @ok="handleRecoverOk"   :maskClosable="config.globlaMaskClosable"
             destroyOnClose>
      <a-form :form="form">
        <div v-if="this.action !='1'">
          <a-form-item label="恢复原因" :label-col=" { span: 6 }" :wrapper-col=" { span: 12 }">
            <a-textarea
              :rows="1"
              v-model="remarkRecover"
              placeholder="..."
              id="describe"
              v-decorator="['remark',
            { initialValue: remarkRecover, rules: [{ required: true, message: '请输入拉黑原因'}]}]"
            />
          </a-form-item>
        </div>

        <div v-if="this.action =='1'">
          <a-form-item label="恢复原因" :label-col=" { span: 6 }" :wrapper-col=" { span: 12 }">
            <a-textarea disabled
                        :rows="1"
                        v-model="remarkRecover"
                        placeholder="..."
                        id="describe2"
                        v-decorator="['remark',
            { initialValue: remarkRecover, rules: [{ required: true, message: '请输入拉黑原因'}]}]"
            />
          </a-form-item>
        </div>
      </a-form>
    </a-modal>
  </a-card>
</template>

<script>
import { STable } from '@/components'
import { blackListPage, blackListDelete } from '@/api/basic'
import { formatDate } from '../../utils/date.js'

export default {
  name: 'BlackList',
  components: {
    STable
  },
  data() {
    return {
      roleId:null,
      RecordRecordId:'',
      recordType:'',
      remarkRecover:'',
      blackRecordId:null,
      action:'',
      recoverModel:false,
      pageSizeOptionsList:['10'],
      visible: false,
      form: this.$form.createForm(this),
      mdl: {},
      // 高级搜索 展开/关闭
      advanced: false,
      // 查询参数
      queryParam: {},
      // 表头
      columns: [
        {
          title: '#',
          scopedSlots: { customRender: 'serial' }
        },
        {
          title: '车号/企业/人员',
          dataIndex: 'name'
        },
        {
          title: '类型',
          dataIndex: 'typeName'
        },
        {
          title: '拉黑原因',
          dataIndex: 'remark'
        },
        {
          title: '拉黑人',
          dataIndex: 'createId',
          width: '120px',
          customRender:(text, row, index) => {
             if (!text) return "";
             if (text === -1) return "manager";
             let userList= this.$store.getters.userList;
             return userList[text];
         }
        },
        {
          title: '拉黑时间',
          sorter: true,
          dataIndex: 'createTime',
          customRender: text => {
            const date = new Date(text)
            return formatDate(date, 'yyyy-MM-dd hh:mm:ss')
          }
        },
       /* {
          title: '创建人',
          dataIndex: 'createId',
          width: '150px',
          customRender:(text, row, index) => {
            if (!text) return "";
            if (text === -1) return "manager";
            let userList= this.$store.getters.userList;
            return userList[text];
          }
        },*/
        {
          title: '更新人',
          dataIndex: 'updateId',
          width: '140px',
          customRender:(text, row, index) => {
            if (!text) return "";
            if (text === -1) return "manager";
            let userList= this.$store.getters.userList;
            return userList[text];
          }
        },
        {
          title: '操作',
          width: '200px',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' }
        }
      ],

      typeSelect: null,

      // 加载数据方法 必须为 Promise 对象
      loadData: parameter => {
        return blackListPage(Object.assign(parameter, this.queryParam)).then(res => {
          return res.data
        })
      },

      selectedRowKeys: [],
      selectedRows: [],

      options: {
        alert: {
          show: false,
          clear: () => {
            this.selectedRowKeys = []
          }
        },
        rowSelection: {
          selectedRowKeys: this.selectedRowKeys,
          onChange: this.onSelectChange
        }
      },
      optionAlertShow: true
    }
  },
  created() {
    this.tableOption()
    this.loadSelect()
    this.roleId = this.$store.getters.roles
  },
  methods: {

    handleRecover(record,action) {
      this.recordType=record.type
      this.RecordRecordId=record.recordId
      this.action=action
      this.blackRecordId = record.id
      if(this.action !='1'){
        this.remarkRecover = ''
      }else{
        this.remarkRecover = record.remarkRecover
      }
      console.log('AAAAAAA')
      console.log(record.remarkRecover)
      this.form = this.$form.createForm(this)
      this.recoverModel = true
    },

    handleRecoverOk(){
      return blackListDelete({ ids: this.blackRecordId,remarkRecover:this.remarkRecover,action:this.action })
        .then(res => {
          // 更新黑名单集合数据
          let blackList = this.$store.getters.blackList
          if (blackList[this.recordType]) {
            let blackListChi = Object.assign({}, blackList[this.recordType])
            if(this.action=='1') {
              delete blackListChi[this.RecordRecordId]
            }
            blackList[this.recordType] = blackListChi
          }
          this.$store.commit('SET_BLACK', blackList)
          if (res.code === '0') {
            this.$refs.table.refresh()
          }
        })
        .catch(e => {
          console.log(e)
        })
        .finally(() => {
          this.action=''
          this.remarkRecover=''
          this.blackRecordId=null
          this.recoverModel = false
          this.recordType=''

        })

    },

    loadSelect() {
      // 从后台拉去下拉列表数据
      this.typeSelect = this.$store.getters.codeList.basic_black_list_type
    },
    filterOption(input, option) {
      // 用于下拉列表可搜索
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
    tableOption() {
      if (!this.optionAlertShow) {
        this.options = {
          alert: {
            show: false,
            clear: () => {
              this.selectedRowKeys = []
            }
          },
          rowSelection: {
            selectedRowKeys: this.selectedRowKeys,
            onChange: this.onSelectChange
          }
        }
        this.optionAlertShow = true
      } else {
        this.options = {
          alert: false,
          rowSelection: null
        }
        this.optionAlertShow = false
      }
    },
    handleDel(record) {
      var nthis = this
      this.$confirm({
        title: '提示',
        content: '确定要还原吗?',
        onOk() {
          return blackListDelete({ ids: record.id })
            .then(res => {
              // 更新黑名单集合数据
              let blackList = nthis.$store.getters.blackList
              if (blackList[record.type]) {
                let blackListChi = Object.assign({}, blackList[record.type])
                delete blackListChi[record.recordId]
                blackList[record.type] = blackListChi
              }
              nthis.$store.commit('SET_BLACK', blackList)
              if (res.code === '0') {
                nthis.$refs.table.refresh()
              }
            })
            .catch(e => {
              console.log(e)
            })
            .finally(() => {})
        },
        onCancel() {}
      })
    },

    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
    },
    toggleAdvanced() {
      this.advanced = !this.advanced
    }
  }
}
</script>
